import { Converter } from '../types/converter';

export const thermalConductivityConverter: Converter = {
  id: 'thermalConductivity',
  name: 'Thermal Conductivity Converter',
  icon: 'Thermometer',
  categories: ['engineering', 'heat'],
  units: [
    // Base SI unit
    { name: 'Watt/Meter/Kelvin', symbol: 'W/(m·K)', factor: 1 },
    
    // Metric units
    { name: 'Watt/Centimeter/Degree Celsius', symbol: 'W/(cm·°C)', factor: 100 },
    { name: 'Kilowatt/Meter/Kelvin', symbol: 'kW/(m·K)', factor: 1000 },
    
    // Calorie-based units
    { name: 'Calorie (IT)/Second/Centimeter/Degree Celsius', symbol: 'cal (IT)/(s·cm·°C)', factor: 418.68 },
    { name: 'Calorie (th)/Second/Centimeter/Degree Celsius', symbol: 'cal (th)/(s·cm·°C)', factor: 418.4 },
    { name: 'Kilocalorie (IT)/Hour/Meter/Degree Celsius', symbol: 'kcal (IT)/(h·m·°C)', factor: 1.163 },
    { name: 'Kilocalorie (th)/Hour/Meter/Degree Celsius', symbol: 'kcal (th)/(h·m·°C)', factor: 1.162222222 },
    
    // BTU-based units
    { name: 'Btu (IT) Inch/Second/Square Foot/Degree Fahrenheit', symbol: 'Btu (IT)·in/(s·ft²·°F)', factor: 519.1654 },
    { name: 'Btu (th) Inch/Second/Square Foot/Degree Fahrenheit', symbol: 'Btu (th)·in/(s·ft²·°F)', factor: 518.873 },
    { name: 'Btu (IT) Foot/Hour/Square Foot/Degree Fahrenheit', symbol: 'Btu (IT)·ft/(h·ft²·°F)', factor: 1.730551 },
    { name: 'Btu (th) Foot/Hour/Square Foot/Degree Fahrenheit', symbol: 'Btu (th)·ft/(h·ft²·°F)', factor: 1.729577 },
    { name: 'Btu (IT) Inch/Hour/Square Foot/Degree Fahrenheit', symbol: 'Btu (IT)·in/(h·ft²·°F)', factor: 0.1442126 },
    { name: 'Btu (th) Inch/Hour/Square Foot/Degree Fahrenheit', symbol: 'Btu (th)·in/(h·ft²·°F)', factor: 0.1441314 }
  ]
};
